import {
  DateTimeStyles,
  DateStyles,
  Formats,
  Configs,
  NumberStyles,
  RelativeStyles,
  TimeZoneNames,
  UnitStyles,
  UnitTypes,
  LanguageSwitcherParentTypes
} from './types';
import { DisplayNameTypes } from './types/styles';

const numberStyles: NumberStyles = {
  currency: 'currency',
  unit: 'unit'
};
const currencyCodeDefault: string = 'USD';
const dateTimeStyles: DateTimeStyles = {
  full: 'full',
  long: 'long',
  medium: 'medium',
  short: 'short'
};
const timeZoneNames: TimeZoneNames = {
  long: 'long',
  short: 'short',
  medium: 'medium'
};
const unitStyles: UnitStyles = {
  long: 'long'
};
export const unitTypes: UnitTypes = {
  day: 'day',
  kilometer: 'kilometer',
  mile: 'mile',
  month: 'month',
  week: 'week',
  year: 'year'
};
export const displayNameTypes: DisplayNameTypes = {
  language: 'language',
  region: 'region',
  script: 'script',
  currency: 'currency'
};

export const en: string = 'en';
export const fr: string = 'fr';
export const de: string = 'de';
export const es: string = 'es';
export const pt: string = 'pt';
export const it: string = 'it';
export const nl: string = 'nl';
export const ro: string = 'ro';

export const enUS: string = 'en-US';
export const enCA: string = 'en-CA';
export const enGB: string = 'en-GB';
export const enAU: string = 'en-AU';
export const frFR: string = 'fr-FR';
export const frCA: string = 'fr-CA';
export const frBE: string = 'fr-BE';
export const frCH: string = 'fr-CH';
export const deDE: string = 'de-DE';
export const deAT: string = 'de-AT';
export const deCH: string = 'de-CH';
export const esES: string = 'es-ES';
export const esMX: string = 'es-MX';
export const esAR: string = 'es-AR';
export const ptPT: string = 'pt-PT';
export const ptBR: string = 'pt-BR';
export const itIT: string = 'it-IT';
export const nlNL: string = 'nl-NL';
export const roRO: string = 'ro-RO';

export const defaultLocale = enUS;
export const defaultLanguage = en;
export const localeCookie: string = '.culture';
export const mvcAppLocaleCookie: string = '.AspNetCore.Culture';
// fallback language must be the first in the group
export const supportedLocales: Array<string> = [enUS, enGB, enAU];

export const additionalSupportedLocales: Array<string> = [
  enCA,
  frFR,
  frCA,
  frBE,
  frCH,
  deDE,
  deAT,
  deCH,
  esES,
  esMX,
  esAR,
  ptPT,
  ptBR,
  itIT,
  nlNL,
  roRO
];

export const supportedLanguages: Array<string> = [en];

export const additionalSupportedLanguages: Array<string> = [fr, de, es, pt, it, nl, ro];

export const languageOptions = [
  { value: enUS, languageCode: en, countryCode: 'US' },
  { value: enGB, languageCode: en, countryCode: 'GB' },
  { value: enAU, languageCode: en, countryCode: 'AU' }
];

export const additionalLanguageOptions = [
  { value: enCA, languageCode: en, countryCode: 'CA' },
  { value: frFR, languageCode: fr, countryCode: 'FR' },
  { value: frCA, languageCode: fr, countryCode: 'CA' },
  { value: frBE, languageCode: fr, countryCode: 'BE' },
  { value: frCH, languageCode: fr, countryCode: 'CH' },
  { value: deDE, languageCode: de, countryCode: 'DE' },
  { value: deAT, languageCode: de, countryCode: 'AT' },
  { value: deCH, languageCode: de, countryCode: 'CH' },
  { value: esES, languageCode: es, countryCode: 'ES' },
  { value: esMX, languageCode: es, countryCode: 'MX' },
  { value: esAR, languageCode: es, countryCode: 'AR' },
  { value: ptPT, languageCode: pt, countryCode: 'PT' },
  { value: ptBR, languageCode: pt, countryCode: 'BR' },
  { value: itIT, languageCode: it, countryCode: 'IT' },
  { value: nlNL, languageCode: nl, countryCode: 'NL' },
  { value: roRO, languageCode: ro, countryCode: 'RO' }
];

export const kilometersInMile: number = 1.60934;
export const imperialLocales: Array<string> = [enUS, enGB];

export const relativeStyles: RelativeStyles = {
  long: 'long',
  short: 'short',
  narrow: 'narrow'
};

export const dateStyles: DateStyles = {
  month: {
    long: 'long',
    numeric: 'numeric'
  },
  year: {
    numeric: 'numeric'
  }
};

export const configs: Configs = {
  currency: {
    style: numberStyles.currency,
    currency: currencyCodeDefault
  },
  dateFull: {
    dateStyle: dateTimeStyles.full
  },
  dateLong: {
    dateStyle: dateTimeStyles.long
  },
  dateMedium: {
    dateStyle: dateTimeStyles.medium
  },
  dateShort: {
    dateStyle: dateTimeStyles.short
  },
  timeShort: {
    timeZoneName: timeZoneNames.short
  },
  timeMedium: {
    timeStyle: timeZoneNames.medium
  },
  relativeLong: { numeric: 'auto', style: relativeStyles.long },
  relativeNarrow: { numeric: 'auto', style: relativeStyles.narrow },
  relativeShort: { numeric: 'auto', style: relativeStyles.short },
  unit: {
    style: numberStyles.unit,
    unitDisplay: unitStyles.long
  }
};

export const formats: Formats = {
  currency: 'currency',
  dateCustom: 'dateCustom',
  dateFull: 'dateFull',
  dateLong: 'dateLong',
  dateMedium: 'dateMedium',
  dateShort: 'dateShort',
  distance: 'distance',
  number: 'number',
  timeShort: 'timeShort',
  timeMedium: 'timeMedium',
  relativeLong: 'relativeLong',
  relativeNarrow: 'relativeNarrow',
  relativeShort: 'relativeShort'
};

export const languageSwitcherParentTypes: LanguageSwitcherParentTypes = {
  header: 'header',
  footer: 'footer',
  registration: 'registration'
};

export const localizationFeatureFlag: string = 'AionLocalizationStatus';
